import { HeadingSectionAPI } from '../components/heading-section/heading-section-api.js';
class SectionAPI extends HeadingSectionAPI {
    /**
     * Returns the section icon.
     */
    getIcon() {
        return this.state.icon;
    }
    /**
     * Sets the section icon.
     *
     * @param icon - The section icon.
     */
    setIcon(icon) {
        this.setState({ icon });
    }
}
export { SectionAPI, };
//# sourceMappingURL=section-api.js.map